import { Flex, Icon, Tooltip } from '@chakra-ui/react'
import React from 'react'
import IconCloseBold from '~/assets/svgs/icon-close-x-bold.svg?react'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { Size } from '~/types/ThemeTypes'

export const PopupButtons = (props: {
  handleOpenMango: () => void
  handleDismiss: () => void
  mainButtonText?: string
  secondaryButtonText?: string
  handleDismissAll?: () => void
}) => {
  const {
    handleOpenMango,
    handleDismiss,
    mainButtonText = 'Open Mango',
    secondaryButtonText = 'Done',
    handleDismissAll,
  } = props

  return (
    <Flex
      direction="row"
      flex="1"
      flexGrow={0}
      paddingTop={1}
      justifyContent={'flex-start'}
      alignItems={'center'}
    >
      <MangoButton onClick={handleOpenMango} flexGrow={1}>
        {mainButtonText}
      </MangoButton>
      <MangoButton
        variant={MangoButtonVariant.Default_100}
        onClick={handleDismiss}
        marginLeft={1}
        flexShrink={1}
      >
        {secondaryButtonText}
      </MangoButton>
      {handleDismissAll && (
        <Tooltip label="Clear All">
          <MangoButton
            size={Size.sm}
            variant={MangoButtonVariant.Default_100}
            onClick={handleDismissAll}
            marginLeft={1}
            flexShrink={1}
          >
            <Icon
              as={IconCloseBold}
              onClick={handleDismissAll}
              flexShrink={1}
            />
          </MangoButton>
        </Tooltip>
      )}
    </Flex>
  )
}
